import moment from 'moment'
import store from '@/vuex/store'

export default {
  getTimeStamp() {
    return parseInt(moment().utc().format('x'), 10)
  },
  getCurTimeStamp() {
    return parseInt(moment().utc().format('x'), 10) - store.state.offsetTime
  },
}
